<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/60KCrI/tc-custom/9780760351383.jpg?1731055737517" alt="This image is the cover for the book Gardening with Chickens"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gardening with Chickens
      </h1>
      <p class="bookDescription body article font2">
        <b>“Beautifully photographed and filled with eye-catching illustrations” this guide to raising chickens alongside vegetables “will become an instant classic” (Niki Jabbour, author of <i>Groundbreaking Food Gardens</i> and <i>The Year Round Vegetable Gardener</i>).</b><br/><br/>Welcome to a world where chickens and gardens coexist! Join Lisa Steele, chicken-keeper extraordinaire and founder of Fresh Eggs Daily, on a unique journey through the garden. Start by planning your garden and learning strategies and tips for keeping your plants safe while they grow. Plant with purpose, choosing from a dozen plans for theme gardens such as Orange Egg Yolks or Nesting Box Herbs. Or choose a design that’s filled with edibles—sharing the bounty with your family and your feathered friends. Then comes the fun part: enjoy the harvest, even let the chickens graze! <br/><br/>Lisa’s friendly writing, together with inspirational photos and illustrations, will have you rolling up your sleeves and reaching for your gardening tools. Lisa also covers a range of topics about chicken-keeping, including:<br/><br/>- Chickens and composting<br/><br/>- Using chickens to aerate and till<br/><br/>- Coop window boxes<br/><br/>- Plants to avoid when you have chickens<br/><br/>- Lists of the most valuable crops and herbs<br/><br/>- Advice on how to harvest and use many of the plants<br/><br/>- And much more!<br/><br/>Whether you’re an experienced chicken keeper, master gardener, or just getting into these two wonderful hobbies<i>, Gardening with Chickens </i>is an indispensable guide for a harmonious homestead.<br/><br/>“Can a garden—especially a tempting vegetable garden—peacefully coexist with hungry, inquisitive chickens?. . . . It’s a smart subject for a book, and the answer, says <i>Gardening With Chickens</i> author Lisa Steele, is that they can not only coexist, but each can benefit the other.” —GardenSmartTV
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Steele
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Voyageur Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?052a5710